export function shouldShowI4hPlansAdministrationEntry(userRole: string | null | undefined) {
  return ["admin", "salvia_operation_admin"].includes(userRole ?? "");
}
